var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-tip",class:_vm.wrapperCls},[[_vm._v(_vm._s(_vm.content))],_vm._v(" "),_c('md-icon',{attrs:{"name":"cross","size":"md"},nativeOn:{"click":function($event){return _vm.$_onClose.apply(null, arguments)}}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77e74f1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/vxmobile/components/tip/tip.vue
// module id = null
// module chunks = 